/* Visibilità e filtri — porting da flusso-urgenze.html (802-814, 1022-1029).
   Filtri in AND fra i gruppi (attori/fasi/documenti/testo), OR dentro il gruppo. */
import { plain } from "./markup.js";
import type { DiagramState, Narrow, PEvent, PreparedModel } from "./model.js";

export function anyFilter(S: DiagramState): boolean {
  return !!(S.actors.size || S.phases.size || S.docs.size || S.q.trim());
}

/** Insieme dei numeri di messaggio che passano i filtri correnti. */
export function computeVisible(model: PreparedModel, S: DiagramState): Set<number> {
  const q = S.q.trim().toLowerCase();
  const vis = new Set<number>();
  for (const m of model.MSGS) {
    const raw = m.raw as Narrow<"msg">;
    if (S.actors.size && !S.actors.has(raw.from) && !S.actors.has(raw.to)) continue;
    if (S.phases.size && !(m.phase && S.phases.has(m.phase.id))) continue;
    if (S.docs.size && !m.docs!.some((d) => S.docs.has(d))) continue;
    if (q && !m.search!.includes(q)) continue;
    vis.add(m.n!);
  }
  return vis;
}

export function noteVisible(ev: PEvent, S: DiagramState): boolean {
  const raw = ev.raw as Narrow<"note">;
  const q = S.q.trim().toLowerCase();
  if (S.actors.size && !S.actors.has(raw.over)) return false;
  if (S.phases.size && !(ev.phase && S.phases.has(ev.phase.id))) return false;
  if (S.docs.size) return false; // le note non citano documenti
  if (q && !plain(raw.text).toLowerCase().includes(q)) return false;
  return true;
}
